import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2AudioIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 26.626 19.422",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 26.626),
    children: /*#__PURE__*/jsx("path", {
      d: "M15.835.97a1.786 1.786 0 00-1.87.169l-7.857 5H2.536A1.786 1.786 0 00.75 7.925v3.572a1.786 1.786 0 001.786 1.785h3.571l7.857 5a1.786 1.786 0 002.857-1.429V2.568a1.786 1.786 0 00-.987-1.6zM24.517 14.173a7.857 7.857 0 000-8.453M21.063 12.617a4.159 4.159 0 000-5.244M6.107 6.139v7.143"
    })
  });
};

export { PM2AudioIcon };
//# sourceMappingURL=audio.js.map
